import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

let baseUrl;

function resolveApiPrefix(rawValue, fallback) {
  const value = (rawValue || "").toString().trim();
  if (!value || value === "undefined" || value === "null") {
    return fallback;
  }
  return value;
}

baseUrl = resolveApiPrefix(process.env.VUE_APP_BASE_URL, "/baseUrl");
const refreshTokenUrl = `${baseUrl}/system/auth/refresh-token`;

let isRefreshing = false;
let requests = [];

const request = axios.create({
  timeout: 60000,
});

const refreshRequest = axios.create({
  timeout: 60000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

request.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Authorization");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["tenant-id"] = "1";
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      return response.data;
    }

    const res = response.data;
    if (res.code === 0) {
      return res;
    }

    if (res.code === 401) {
      return handleUnauthorized();
    }

    if (res.ResultCode !== 0 && res.msg) {
      Message.warning(res.msg);
    }
    return res;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      return handleUnauthorized(error.config);
    }
    return Promise.reject(error.response || error);
  }
);

function handleUnauthorized(originalRequest) {
  if (!originalRequest) {
    redirectToLogin();
    return Promise.reject("Unauthorized");
  }

  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    redirectToLogin();
    return Promise.reject("No refresh token");
  }

  if (isRefreshing) {
    return new Promise((resolve) => {
      requests.push(() => {
        const token = localStorage.getItem("Authorization");
        originalRequest.headers.Authorization = `Bearer ${token || ""}`;
        resolve(request(originalRequest));
      });
    });
  }

  isRefreshing = true;

  return new Promise((resolve, reject) => {
    refreshRequest
      .post(refreshTokenUrl, { refreshToken })
      .then((response) => {
        const { data } = response;
        if (data.code !== 0) {
          throw new Error("Refresh token failed");
        }

        const newToken = data.data.accessToken;
        const newRefreshToken = data.data.refreshToken;

        localStorage.setItem("Authorization", newToken);
        localStorage.setItem("refreshToken", newRefreshToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        requests.forEach((cb) => cb());
        requests = [];

        resolve(request(originalRequest));
      })
      .catch((err) => {
        redirectToLogin();
        reject(err);
      })
      .finally(() => {
        isRefreshing = false;
      });
  });
}

function redirectToLogin() {
  localStorage.removeItem("Authorization");
  localStorage.removeItem("refreshToken");
  Message.warning("Login expired, please login again");
  router.push("/");
}

export default request;
